import { styled } from "@mui/material";
const More = styled("div", {
  name: "TruncateMore",
  skipSx: true,
  slot: "Root"
})`
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: 1 0 auto;
  background-color: var(--show-more-color, #ffffff);
  padding: 0px;
`;
export {
  More
};
//# sourceMappingURL=More.js.map
